export function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        ...style,
        display: "block",
        position: "absolute",
        right: "10px",
        zIndex: 50, // ensure on top of image
      }}
    />
  );
}

export function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        ...style,
        display: "block",
        position: "absolute",
        left: "10px",
        zIndex: 50,
      }}
    />
  );
}
